<template>
  <label
    :for="id"
    class="check-box"
  >
    <input
      type="Checkbox"
      :id="id"
      @input="model = !model"
      :value="true"
    >
    <span><slot /></span>
  </label>
</template>

<script>
export default {

  name: 'Checkbox',

  props: {
    id: { type: String, default: String.fromCharCode(65 + Math.floor(Math.random() * 26)) + '_' + Date.now() }
  },

  data () {
    return {
      model: false
    }
  },

  watch: {
    model (a) {
      this.$emit('input', a)
    }
  }
}
</script>
